import { store } from "@/store";

export const WORKBENCH_API_BASE = (
  process.env.VUE_APP_WORKBENCH_API_BASE ||
  "https://api.yjllq.com/index.php/api/Workbench"
).replace(/\/+$/, "");

async function request(path, options = {}) {
  const headers = new Headers(options.headers || {});
  headers.set("Authorization", `Bearer ${store.token || ""}`);
  if (options.body && !(options.body instanceof FormData))
    headers.set("Content-Type", "application/json");
  const response = await fetch(`${WORKBENCH_API_BASE}/${path}`, {
    ...options,
    headers,
  });
  const result = await response
    .json()
    .catch(() => ({ code: response.status, msg: "服务器返回不是有效 JSON" }));
  if (!response.ok || result.code === 401)
    throw new Error(result.msg || "登录已失效");
  if (result.code !== 0) throw new Error(result.msg || "请求失败");
  return result.data;
}

export const listWorkbenches = () => request("index");
export const getWorkbench = (id) =>
  request(`detail?id=${encodeURIComponent(id)}`);
export const getWorkbenchContent = async (id) => {
  const data = await request(`content?id=${encodeURIComponent(id)}`, {
    cache: "no-store",
  });
  if (!data || data.encoding !== "base64" || !data.content_base64)
    throw new Error("服务器未返回有效的工作台内容");
  let binary;
  try {
    binary = window.atob(data.content_base64);
  } catch (error) {
    throw new Error("工作台内容 Base64 解码失败");
  }
  const bytes = new Uint8Array(binary.length);
  for (let index = 0; index < binary.length; index += 1)
    bytes[index] = binary.charCodeAt(index);
  if (Number(data.size) !== bytes.byteLength)
    throw new Error("工作台内容不完整，请重新加载");
  return new TextDecoder("utf-8").decode(bytes);
};
export const getWorkbenchVersions = (id) =>
  request(`versions?id=${encodeURIComponent(id)}`);
export const createWorkbench = (payload) =>
  request("create", { method: "POST", body: JSON.stringify(payload) });
export const regenerateWorkbench = (payload) =>
  request("regenerate", { method: "POST", body: JSON.stringify(payload) });
export const modifyWorkbenchStep = (payload, signal) =>
  request("modify", {
    method: "POST",
    body: JSON.stringify(payload),
    signal,
  });
export const modifyUserscriptStep = (payload, signal) =>
  request("modifyUserscript", {
    method: "POST",
    body: JSON.stringify(payload),
    signal,
  });
export const importWorkbench = (file, name = "") => {
  const form = new FormData();
  form.append("file", file);
  if (name) form.append("name", name);
  return request("import", { method: "POST", body: form });
};
export const saveWorkbench = (payload) =>
  request("save", { method: "POST", body: JSON.stringify(payload) });
export const restoreWorkbench = (id, versionId) =>
  request("restore", {
    method: "POST",
    body: JSON.stringify({ id, version_id: versionId }),
  });
export const renameWorkbench = (id, name) =>
  request("rename", { method: "POST", body: JSON.stringify({ id, name }) });
export const deleteWorkbench = (id) =>
  request("delete", { method: "POST", body: JSON.stringify({ id }) });
